import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { toast } from "sonner";
import { DIVISIONS, ROLE_LABEL } from "../lib/constants";
import { formatDate, formatApiError } from "../lib/format";

const ASSIGNABLE_ROLES = ["division_staff", "division_admin", "division_manager", "content_creator", "general_manager", "admin"];

export default function PendingUsers() {
  const [rows, setRows] = useState([]);
  const [target, setTarget] = useState(null);
  const [form, setForm] = useState({ role: "division_staff", division_id: "", position: "", reason: "" });

  const load = () => api.get("/users/pending").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);

  const openApprove = (u) => {
    setTarget(u);
    setForm({ role: "division_staff", division_id: u.requested_division_id || "", position: u.requested_role || "", reason: "" });
  };

  const approve = async () => {
    try {
      await api.post(`/users/${target.id}/approve`, form);
      toast.success("Akun disetujui"); setTarget(null); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const reject = async (u) => {
    if (!window.confirm(`Tolak pengajuan ${u.name}?`)) return;
    await api.post(`/users/${u.id}/reject`); toast.success("Ditolak"); load();
  };

  return (
    <div className="space-y-6" data-testid="pending-users">
      <div>
        <h1 className="font-display text-2xl font-bold">Verifikasi Karyawan</h1>
        <p className="text-sm text-[#5C6066] mt-1">Peninjauan dan persetujuan akun karyawan baru (khusus Owner).</p>
      </div>
      <Card className="border border-[#E5E0D8] bg-white shadow-none overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs uppercase tracking-wider text-[#8C9096] bg-[#FAF6EE]">
                <th className="text-left px-5 py-3">Nama</th>
                <th className="text-left px-4 py-3">Kontak</th>
                <th className="text-left px-4 py-3">Divisi Diminta</th>
                <th className="text-left px-4 py-3">Peran Diminta</th>
                <th className="text-left px-4 py-3">Dibuat</th>
                <th className="text-right px-4 py-3">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-[#8C9096]">Tidak ada pengajuan menunggu.</td></tr>}
              {rows.map((u) => (
                <tr key={u.id} className="border-t border-[#F0EBE0] hover:bg-[#F7F4EE]" data-testid={`pending-row-${u.id}`}>
                  <td className="px-5 py-3">
                    <div className="font-medium">{u.name}</div>
                    <div className="text-[11px] text-[#8C9096]">{u.email}</div>
                  </td>
                  <td className="px-4 py-3 text-[#5C6066]">{u.whatsapp}</td>
                  <td className="px-4 py-3">{u.requested_division?.name || "-"}</td>
                  <td className="px-4 py-3 text-[#5C6066]">{u.requested_role || "-"}</td>
                  <td className="px-4 py-3 text-[#8C9096] text-xs">{formatDate(u.created_at)}</td>
                  <td className="px-4 py-3 text-right">
                    <Button size="sm" onClick={() => openApprove(u)} className="bg-brand text-white mr-2" data-testid={`btn-approve-${u.id}`}>Setujui</Button>
                    <Button size="sm" variant="outline" onClick={() => reject(u)} data-testid={`btn-reject-${u.id}`}>Tolak</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      <Dialog open={!!target} onOpenChange={(o) => !o && setTarget(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Setujui {target?.name}</DialogTitle></DialogHeader>
          {target && (
            <div className="space-y-3 py-2">
              <div className="text-xs bg-[#FAF6EE] rounded p-3 border border-[#E5E0D8]">
                Diminta: <span className="font-medium">{target.requested_role}</span> di <span className="font-medium">{target.requested_division?.short}</span>
              </div>
              <div><Label>Peran Final</Label>
                <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
                  <SelectTrigger className="mt-1.5" data-testid="approve-role"><SelectValue /></SelectTrigger>
                  <SelectContent>{ASSIGNABLE_ROLES.map((r) => <SelectItem key={r} value={r}>{ROLE_LABEL[r]}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              <div><Label>Divisi Final</Label>
                <Select value={form.division_id} onValueChange={(v) => setForm({ ...form, division_id: v })}>
                  <SelectTrigger className="mt-1.5"><SelectValue placeholder="Pilih" /></SelectTrigger>
                  <SelectContent>{DIVISIONS.map((d) => <SelectItem key={d.id} value={d.id}>{d.short}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              <div><Label>Posisi</Label><Input className="mt-1.5" value={form.position} onChange={(e) => setForm({ ...form, position: e.target.value })} /></div>
              <div><Label>Alasan (untuk audit)</Label><Input className="mt-1.5" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} /></div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setTarget(null)}>Batal</Button>
            <Button className="bg-brand text-white" onClick={approve} data-testid="btn-confirm-approve">Setujui</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
